import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import TopMenu from "../../TopMenu";
import TableDocument from "../../TableDocument";
import FilterModal from "../../../../Components/Common/FilterModal";
import { get } from "../../../../utils/api";
import { useUser } from "../../../../context/AuthContext";

const CapitalGoodsDocuments = () => {
  const { user } = useUser();
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const columnWidth = user?.companyAdmin
    ? "10% 10% 11% 14% 14% 14% 14% 9%"
    : "11% 12% 15% 16% 16% 16% 8%";

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [url, setUrl] = useState("road");
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const [filter, setFilter] = useState({
    capitalGoodsName: [],
    capitalGoodsCategory: [],
    supplierName: [],
    country: [],
  });

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
  };

  const handleToggle = (option, nextUrl) => {
    setSelectedOption(option);
    setUrl(nextUrl);
  };

  let filtersToApply = {};

  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        facilityList: selectedFacility.join(","),
        limit: 10,
        search: searchQuery,
      }).toString();

      const response = await get(
        `/scope3/capitalGoodsEmissions/documents?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`
      );
      setData(response.data.data);
      setTotalPages(response.data.totalPages);
      setPage(response.data.currentPage);
    } catch (error) {
      console.error("Error fetching capital goods documents:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, url, fromDate, toDate, selectedFacility, searchQuery]);

  // const fetchFilter = async () => {
  //   try {
  //     const response = await get(`/scope3/capitalGoodsEmissions/filter`);
  //     const apiFilterData = response.data?.data || {};
  //     setFilter({
  //       capitalGoodsName:
  //         apiFilterData?.capitalGoodsName || apiFilterData?.goodsName || [],
  //       capitalGoodsCategory:
  //         apiFilterData?.capitalGoodsCategory || apiFilterData?.category || [],
  //       supplierName:
  //         apiFilterData?.supplierName || apiFilterData?.supplier || [],
  //       country: apiFilterData?.country || [],
  //     });
  //   } catch (error) {
  //     console.error("Error fetching capital goods document filters:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchFilter();
  // }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const heading = [
    {
      title: "Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      title: "Purchase Date",
      key: "purchaseDate",
    },
    {
      title: "Capital Good",
      key: "capitalGoodsName",
    },
    {
      title: "Category",
      key: "capitalGoodsCategory",
    },
    {
      title: "Supplier",
      key: "supplierName",
    },
    {
      title: "Quantity",
      key: "quantity",
    },
  ].filter(Boolean);

  const filterData = [
    { title: "Date", type: "date", key: "date", value: [] },
    { title: "Purchase Date", type: "date", key: "purchaseDate", value: [] },
    {
      title: "Capital Goods Name",
      type: "option",
      key: "capitalGoodsName",
      value: filter.capitalGoodsName || [],
    },
    {
      title: "Capital Goods Category",
      type: "option",
      key: "capitalGoodsCategory",
      value: filter.capitalGoodsCategory || [],
    },
    {
      title: "Supplier Name",
      type: "option",
      key: "supplierName",
      value: filter.supplierName || [],
    },
    {
      title: "Country of Manufacture",
      type: "option",
      key: "country",
      value: filter.country || [],
    },
  ];

  const toggleData = [];

  return (
    <MainDashboardLayout sidebar={<DocumentationSidebar />}>
      <TopMenu
        {...{
          setDrawerFilterOpen: setIsFilterModalOpen,
          selectedMonth,
          setSelectedMonth,
          selectedYear,
          setSelectedYear,
          selectedOption,
          handleToggle,
          filterApplied: isFiltersApplied,
          toggleData,
          fromDate,
          setFromDate,
          toDate,
          setToDate,
          selectedFacility,
          setSelectedFacility,
          searchQuery,
          setSearchQuery,
          fetchData,
        }}
        heading="Capital Goods"
      />

      <TableDocument
        data={data}
        totalPages={totalPages}
        page={page}
        handleChangePage={handleChangePage}
        headers={heading}
        columnWidth={columnWidth}
      />
{/* 
      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filterData}
        onFilterChange={handleFilterChange}
        title="Filter"
      /> */}
    </MainDashboardLayout>
  );
};

export default CapitalGoodsDocuments;
